import React from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";

function Report() {
  return (
    <>
      <Sidebar openItem="all-finance" activeItem="report-finance" />

      <div className="content-wrapper">
        <TitleBar title="گزارش مالی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body"></div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Report;
